export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    getById (context, payload) {
      const promise = this.server.questionById(payload)
      return promise
    },
    add (context, payload) {
      const promise = this.server.addQuestion(payload)
      return promise
    },
    update (context, payload) {
      const promise = this.server.updateQuestion(payload)
      return promise
    },
    remove (context, payload) {
      const promise = this.server.deleteQuestion(payload)
      return promise
    }
  }
}
